import React from 'react';
import Barcode from 'react-barcode';
import { Box, Paper, Typography, useTheme, useMediaQuery } from '@mui/material';

interface BarcodeDisplayProps {
  value: string;
  showLabel?: boolean;
  width?: number | { xs?: number; sm?: number; md?: number };
  height?: number | { xs?: number; sm?: number; md?: number };
}

const BarcodeDisplay: React.FC<BarcodeDisplayProps> = ({
  value,
  showLabel = true,
  width = 2,
  height = 50,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  // 반응형 값 계산
  const getResponsiveValue = (val: number | { xs?: number; sm?: number; md?: number }): number => {
    if (typeof val === 'number') return val;
    
    if (isMobile) return val.xs || val.sm || val.md || 1.5;
    if (isTablet) return val.sm || val.md || 2;
    return val.md || 2.5;
  };

  // 금형번호 길이에 따라 width 조정 (긴 번호는 얇은 바 사용)
  const getAdjustedWidth = (baseWidth: number, text: string): number => {
    const length = text.length;
    
    if (length <= 10) {
      return baseWidth; // 100%
    } else if (length <= 15) {
      return baseWidth * 0.75; // 75%
    } else if (length <= 20) {
      return baseWidth * 0.6; // 60%
    } else {
      return baseWidth * 0.5; // 50%
    }
  };

  const baseWidth = getResponsiveValue(width);
  const finalWidth = getAdjustedWidth(baseWidth, value);
  const finalHeight = getResponsiveValue(height);

  return (
    <Paper elevation={2} sx={{ p: { xs: 1.5, sm: 2 }, textAlign: 'center' }}>
      {showLabel && (
        <Typography variant="caption" display="block" gutterBottom>
          바코드
        </Typography>
      )}
      <Box sx={{ 
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'auto'
      }}>
        <Barcode
          value={value}
          width={finalWidth}
          height={finalHeight}
          format="CODE128"
          displayValue={true}
          background="#ffffff"
          lineColor="#000000"
        />
      </Box>
    </Paper>
  );
};

export default BarcodeDisplay;
